import FiscalDocTypeCodeEnum from '@/api/Enums/FiscalDocTypeCodeEnum'

export default {
  Title: 'Statistics',

  Product: {
    Title: 'Product Statistics',
    Table: {
      Headers: {
        Id          : '#',
        CategoryName: 'Category',
        CatalogName : 'Catalog',
        Name        : 'Product',
        Quantity    : 'Orders',
        UnitQuantity: 'Quantity',
        Sales       : 'Total Sales',
        VatRate     : 'Vat Ratio',
        Vat         : 'Vat Total',
        Net         : 'Net Total'
      },
      Summary: {
        Title: 'Current Page Totals'
      },
      Filter: {
        filterCategory: {
          Type       : 'v-select',
          Chips      : true,
          Multiple   : false,
          Label      : 'Product Category',
          PlaceHolder: 'All Product Categories',
          ItemText   : 'Name',
          ItemValue  : 'Id',
          ItemDesc   : 'Description',
          Items      : []
        }
      }
    },

    Export: {
      Title         : 'Export',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Soon you\'ll receive a file with the exported product statistics at the email(s) you selected'
    }
  },

  SalesReportOrders: {
    Title: 'Sales Order Report'
  },

  SalesReportReceiptsZ: {
    Title: 'Sales Fiscal Doc Report (Z)',
    Table: {
      Headers: {
        Source     : 'Source',
        Order      : 'Order',
        Receipt    : 'Fiscal Doc',
        ReceiptType: 'Fiscal Doc Type',
        Total      : 'Total',
        Date       : 'Date'
      }
    },

    Export: {
      Title         : 'Export',
      Icon          : 'file_download',
      Color         : 'primary',
      SuccessMessage: 'Soon you\'ll receive the report at your email: {email}'
    },

    Filter: {
      filterOrderType: {
        Type       : 'v-btn-toggle',
        Label      : 'Orders',
        PlaceHolder: 'All Orders',
        ItemText   : 'Name',
        ItemValue  : 'Value',
        Items      : [
          {
            Value: 0,
            Name : 'All'
          },
          {
            Value: 1,
            Name : 'With Receipt',
            Icon : 'mdi-receipt-text',
            Color: 'green',
            Class: 'white--text'
          },
          {
            Value: 2,
            Name : 'Without Receipt',
            Icon : 'mdi-receipt-text-remove',
            Color: 'orange',
            Class: 'white--text'
          }
        ]
      },

      filterInvoiceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : false,
        Label      : 'Fiscal Doc Type',
        PlaceHolder: 'All fiscal doc types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : [
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_INVOICE,
            Name  : 'Sales Invoice',
            Avatar: {
              Color: 'blue',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_1,
            Name  : 'Credit Invoice / Associated',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_INVOICE_CREDIT_2,
            Name  : 'Credit Invoice / Not Associated',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SALE_RECEIPT,
            Name  : 'Retail Receipt',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_SERVICE_RECEIPT,
            Name  : 'Services Receipt',
            Avatar: {
              Color: 'green',
              Icon : 'mdi-receipt-text'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_RECEIPT_CREDIT,
            Name  : 'Credit Retail Receipt',
            Avatar: {
              Color: 'red',
              Icon : 'mdi-receipt-text-remove'
            }
          },
          {
            Id    : FiscalDocTypeCodeEnum.GREEK_DOCUMENT_ORDER,
            Name  : 'Order Report',
            Avatar: {
              Color: 'blue-grey',
              Icon : 'mdi-receipt-text'
            }
          }
        ]
      },

      filterSourceType: {
        Type       : 'v-select',
        Chips      : true,
        Multiple   : true,
        Label      : 'Source Type',
        PlaceHolder: 'All Source Types',
        ItemText   : 'Name',
        ItemValue  : 'Id',
        ItemDesc   : 'Description',
        Items      : []
      }
    }
  },

  OrdersHeatmap: {
    Title : 'Orders Heatmap',
    Orders: 'Data from {orders} orders'
  }
}
